<template>
    <div>
        <div class="form-group col-12">
            <label for="title">Title</label>

            <input
                id="title"
                v-model="footerColumn.title"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('title')
                }"
                dir="auto"
                placeholder="title"
            />

            <div class="invalid-feedback">
                {{ getError('title') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="order">Order</label>

            <v-select
                id="order"
                v-model="footerColumn.order"
                :class="{ 'is-invalid': hasError('order') }"
                :options="options"
                :clearable="false"
            />

            <div class="invalid-feedback">
                {{ getError('order') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            footerColumn: {},
            options: [1, 2, 3]
        };
    },

    watch: {
        footerColumn() {
            this.$emit('input', this.footerColumn);
        }
    },

    mounted() {
        this.footerColumn = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.footerColumn[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.footerColumn,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
